/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import MenuItem from "@mui/material/MenuItem";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import ClearIcon from "@mui/icons-material/Clear";

// Material Dashboard 2 React examples
import DataTable from "examples/Tables/DataTable";

// Data
import data from "layouts/dashboard/components/Projects/data";
import useDashboard from "hooks/useDashboard";
import MDButton from "components/MDButton";
import { Grid, IconButton, InputAdornment, Select } from "@mui/material";
import useTerritory from "hooks/useTerritory";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import CustomPagination from "examples/CustomPagination/CustomPagination";
import { useMaterialUIController } from "context";
function Projects() {
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const { getDealersPerformance, dealersPerformance } = useDashboard();
  const { getTerritoryOptions } = useTerritory();
  const { columns, rows } = data();
  const [selectedOption, setSelectedOption] = useState("");
  const [territoryOption, setTerritoryOption] = useState([]);
  // Pagination states
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPage, setTotalPage] = useState(1);
  const [total, setTotal] = useState(0);

  const handleChange = (event) => {
    event.preventDefault();
    setSelectedOption(event.target.value);
    getDealersPerformance({ territory: event.target.value });
  };
  const handlePageChange = (newPage) => {
    setPage(newPage);
    getDealersPerformance({ limit: 10, page: newPage, territory: selectedOption });
  };

  useEffect(() => {
    getTerritoryOptions().then((res) => {
      if (res.success) {
        const formattedOptions = res.data.map(({ _id, name }) => ({
          label: name,
          value: _id,
        }));
        setTerritoryOption(formattedOptions);
      }
    });
  }, []);
  useEffect(() => {
    if (dealersPerformance.page && dealersPerformance.limit) {
      setPage(dealersPerformance.page);
      setLimit(dealersPerformance.limit);
      setTotalPage(dealersPerformance.pages || 1);
      setTotal(dealersPerformance.total || 0);
    }
  }, [dealersPerformance]);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={2}
                px={2}
                variant="gradient"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow={sidenavColor}
              >
                <MDTypography variant="h6" color="white">
                  All Top Dealers
                </MDTypography>
                <Select
                  value={selectedOption}
                  onChange={handleChange}
                  fullWidth
                  variant="outlined"
                  displayEmpty
                  sx={{
                    height: "40px",
                    width: "200px",
                    marginRight: "10px",
                    backgroundColor: "#fff",
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      {selectedOption ? (
                        <IconButton
                          onClick={() => {
                            setSelectedOption("");
                            getDealersPerformance();
                          }}
                          edge="end"
                        >
                          <ClearIcon />
                        </IconButton>
                      ) : (
                        <UnfoldMoreIcon />
                      )}
                    </InputAdornment>
                  }
                >
                  <MenuItem value="" disabled>
                    Select a territory
                  </MenuItem>
                  {territoryOption.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  showTotalEntries={false}
                  isSorted={false}
                  noEndBorder
                  entriesPerPage={false}
                />
              </MDBox>
            </Card>
            <MDBox
              sx={{ width: "100%", display: "flex", justifyContent: "start", marginTop: "1rem" }}
            >
              <CustomPagination
                totalCount={totalPage}
                currentPage={page}
                onPageChange={handlePageChange}
              />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default Projects;
